/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

interface ErrorMessageProps {
  errors: any;
}

function ErrorMessage({ errors }: ErrorMessageProps) {
  // TODO remover trativa de erro quando a api atualizar as rotas
  const hasErrorMessages = errors?.[0]?.messages;

  return (
    <div>
      <strong>[ERR400]:</strong>
      <div>
        {hasErrorMessages
          ? errors
              ?.map((error: any) => error?.messages?.join(' - '))
              ?.map((error: any, i: number) => <div key={i}>{error}</div>)
          : errors?.map((error: any, i: number) => <div key={i}>{error}</div>)}
      </div>
    </div>
  );
}

export { ErrorMessage };
